export default "/directory/static/destination_available.50542147.svg";